import { render, staticRenderFns } from "./ActivityHistory.vue?vue&type=template&id=2579206e&scoped=true&lang=pug"
import script from "./ActivityHistory.vue?vue&type=script&lang=js"
export * from "./ActivityHistory.vue?vue&type=script&lang=js"
import style0 from "./ActivityHistory.vue?vue&type=style&index=0&id=2579206e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579206e",
  null
  
)

export default component.exports